import React, {Component} from 'react';
import {createRefetchContainer, graphql} from 'react-relay';
import {injectIntl} from 'react-intl';
import {formatMinutesRound, formatCurrencyRound} from '../../../../forecast-app/shared/util/util';

class studioDashboardComponent extends Component {
	constructor(props) {
		super(props);
		props.relay.refetch({
			componentId: props.id,
		});
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		const {dateSpan} = nextProps;
		if (dateSpan !== this.props.dateSpan) {
			let dateSpanString = '';
			if (dateSpan) {
				if (dateSpan.key === 'custom-date-range') {
					dateSpanString = `${dateSpan.value.start.format('DD/MM/YYYY')}_${dateSpan.value.end.format('DD/MM/YYYY')}`;
				} else {
					dateSpanString = dateSpan.value;
				}
			}
			this.props.relay.refetch({
				dateCriteria: dateSpanString,
			});
		}
	}

	setExportData() {
		const {setExportColumns, setExportData, columns} = this.props;
		const {studioDashboard} = this.props.viewer.insightComponentsData;
		const exportData = [studioDashboard];
		setExportColumns(columns);
		setExportData(exportData);
	}

	getTableRow(column, index) {
		const {formatMessage} = this.props.intl;
		const {studioDashboard} = this.props.viewer.insightComponentsData;
		const value = studioDashboard[column];
		return (
			<div className="table-row" key={index}>
				<div className="table-cell text">{formatMessage({id: `insights.component.list.column.${column}`})}</div>
				<div className="table-cell value">{column.startsWith('minutes') ? formatMinutesRound(value) : formatCurrencyRound(value, studioDashboard.currency)}</div>
			</div>
		);
	}

	render() {
		this.setExportData();
		return (
			<div className="insight-component-studio-dashboard">
				<div className="studio-dashboard-table">{this.props.columns.map((column, index) => this.getTableRow(column, index))}</div>
			</div>
		);
	}
}

const studioDashboardComponentQuery = graphql`
	query studioDashboardComponent_Query($shareKey: String, $componentId: ID, $dateCriteria: String) {
		viewer {
			actualPersonId
			component(name: "studio_dashboard")
			...studioDashboardComponent_viewer @arguments(shareKey: $shareKey, componentId: $componentId, dateCriteria: $dateCriteria)
		}
	}
`;

export {studioDashboardComponentQuery};

export default injectIntl(
	createRefetchContainer(
		studioDashboardComponent,
		{
			viewer: graphql`
				fragment studioDashboardComponent_viewer on Viewer @argumentDefinitions(shareKey: {type: "String"}, componentId: {type: "ID"}, dateCriteria: {type: "String"}) {
					insightComponentsData(shareKey: $shareKey) {
						studioDashboard(componentId: $componentId, dateCriteria: $dateCriteria) {
							id
							currency
							minutesAllRemaining
							minutesAllForecast
							minutesAllTimeRegs
							minutesBillableRemaining
							minutesBillableForecast
							minutesBillableTimeRegs
							minutesNonBillableRemaining
							minutesNonBillableForecast
							minutesNonBillableTimeRegs
							costAllRemaining
							costAllForecast
							costAllTimeRegs
							costBillableRemaining
							costBillableForecast
							costBillableTimeRegs
							costNonBillableRemaining
							costNonBillableForecast
							costNonBillableTimeRegs
							priceAllRemaining
							priceAllForecast
							priceAllTimeRegs
							priceBillableRemaining
							priceBillableForecast
							priceBillableTimeRegs
							priceNonBillableRemaining
							priceNonBillableForecast
							priceNonBillableTimeRegs
							expensesCost
							expensesPrice
						}
					}
				}
			`,
		},
		graphql`
			query studioDashboardComponentRefetchQuery($shareKey: String, $componentId: ID, $dateCriteria: String) {
				viewer {
					...studioDashboardComponent_viewer @arguments(shareKey: $shareKey, componentId: $componentId, dateCriteria: $dateCriteria)
				}
			}
		`
	)
);
